import type { MenuItem, MenuListEntry } from "./Menu";

/** Default desktop menu panel and row width for single-line actions. */
export const MENU_PANEL_WIDTH_DEFAULT = "w-[215px]";

/** Wider desktop row width for longer single-line action labels (e.g. the profile menu). */
export const MENU_PANEL_WIDTH_WIDE = "w-[320px]";

/** Wider desktop panel for rows with supporting text and/or copy controls. */
export const MENU_PANEL_WIDTH_DETAIL = "w-[24rem]";

function isMenuItem(item: MenuListEntry): item is MenuItem {
  return item.type !== "headline";
}

/** Detail rows need a wider panel so label, supporting text, and copy controls fit on one line. */
export function menuNeedsDetailWidth(menuItems: MenuListEntry[]): boolean {
  return menuItems.some((item) => isMenuItem(item) && (Boolean(item.supportingText) || item.copyable === true));
}

/** Caller `menuClassName` wins; otherwise widen automatically for detail rows. */
export function resolveMenuPanelClassName(menuItems: MenuListEntry[], menuClassName?: string): string | undefined {
  if (menuClassName) return menuClassName;
  return menuNeedsDetailWidth(menuItems) ? MENU_PANEL_WIDTH_DETAIL : undefined;
}
